import { ref, toValue } from 'vue';
import { SPORT_LIVE_TV_FILTER_GROUPS, createSportLiveTvEmptySelection } from '@/sport-live-tv/constants';
import { toggleSportLiveTvValue } from '@/sport-live-tv/helpers';

export const useSportLiveTvFilterDraft = (selection) => {
  const { leagues, teams } = toValue(selection);
  const draft = ref({ leagues: [...leagues], teams: [...teams] });

  const toggle = (group, value) => {
    draft.value =
      group === SPORT_LIVE_TV_FILTER_GROUPS.leagues
        ? { ...draft.value, leagues: toggleSportLiveTvValue(draft.value.leagues, Number(value)) }
        : { ...draft.value, teams: toggleSportLiveTvValue(draft.value.teams, value) };
  };

  const clear = () => {
    draft.value = createSportLiveTvEmptySelection();
  };

  return { draft, toggle, clear };
};
